<div bp="grid">
  <img
    bp="offset-5@md 4@md 12@sm"
    src="handwashing.png"
    alt="how to wash your hands properly"
  />
</div>

<style>
  img {
    max-width: 100%;
  }
</style>
